import React from 'react'
import { t } from 'ttag'
import PropTypes from 'prop-types'

const MajorInfo = ({ item }) => {
  const completedBy = () => {
    if (item.relevantInfo.completionsInArea?.completionsTotal) {
      const region = item.relevantInfo.completionsInArea.region
      const formattedCompletions = item.relevantInfo.completionsInArea.completionsTotal.toLocaleString()

      return (
        <div className="personalization-item">
          <i className="fal fa-graduation-cap"></i>{' '}
          {t`Students in ${region} Completing: ${formattedCompletions}`}
        </div>
      )
    }

    return null
  }
  const offeredBy = () => {
    if (item.relevantInfo.completionsInArea?.institutionsOffering) {
      const formattedOfferings = item.relevantInfo.completionsInArea.institutionsOffering.toLocaleString()
      const region = item.relevantInfo.completionsInArea.region

      return (
        <div className="personalization-item">
          <i className="fal fa-university"></i>{' '}
          {t`Institutions in ${region} Offering: ${formattedOfferings}`}
        </div>
      )
    }

    return null
  }

  return (
    <div className="personalization-holder">
      {completedBy()}
      {offeredBy()}
    </div>
  )
}

MajorInfo.propTypes = {
  item: PropTypes.object
}

export { MajorInfo }
